<div id="grid1ConfigDiv" class="grid-container">
  <!--Testata configurazione colonne-->
  <dx-data-grid
    id="gridConfig2"
    [allowColumnResizing]="true"
    [dataSource]="gridConf.cols"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    (onRowUpdated)="onConfigRowUpdating($event)"
    [height]="(windowSize.contentHeight ?? 0) - tabsHeight"
    (onToolbarPreparing)="hideButtons($event)"
    (onEditingStart)="saveData()"
  >
    <dxi-column
      dataField="dataField"
      [caption]="'Id' | siaTranslate"
    ></dxi-column>
    <!-- <dxi-column
      dataField="caption"
      [caption]="'Nome' | siaTranslate"
    ></dxi-column> -->
    <dxi-column
      dataField="visibleIndex"
      [caption]="'Ord.' | siaTranslate"
      dataType="number"
      alignment="center"
      sortOrder="asc"
      width="80px"
      [visible]="false"
    ></dxi-column>
    <dxi-column
      dataField="groupIndex"
      [caption]="'Raggrup.' | siaTranslate"
      dataType="number"
      alignment="center"
      width="80px"
    ></dxi-column>
    <!-- <dxi-column
      dataField="cellEditor"
      [caption]="'Editor' | siaTranslate"
      alignment="center"
      width="100px"
    >
      <dxo-lookup
        [dataSource]="gridConfEditorTypes"
        displayExpr="name"
        valueExpr="id"
      >
      </dxo-lookup>
    </dxi-column> -->
    <dxi-column
      dataField="cellTemplate"
      [caption]="'Template' | siaTranslate"
      alignment="center"
      width="150px"
    >
      <dxo-lookup
        [dataSource]="gridConfTemplateTypes"
        displayExpr="name"
        valueExpr="id"
      >
      </dxo-lookup>
    </dxi-column>
    <dxi-column
      dataField="cellEditTemplate"
      [caption]="'Edit. Template' | siaTranslate"
      alignment="center"
      width="150px"
    >
      <dxo-lookup
        [dataSource]="gridConfEditTemplateTypes"
        displayExpr="name"
        valueExpr="id"
      >
      </dxo-lookup>
    </dxi-column>
    <dxi-column
      dataField="cellTemplateParam"
      [caption]="'Parametro Editor o Template' | siaTranslate"
      alignment="left"
    >
    </dxi-column>
    <dxi-column
      dataField="onClick"
      [caption]="'Evento di click' | siaTranslate"
      alignment="left"
    >
    </dxi-column>
    <dxi-column
      dataField="clickEnableCondition"
      [caption]="'Condizione abilitazione click' | siaTranslate"
      alignment="left"
    >
    </dxi-column>
    <dxi-column
      dataField="iconWidth"
      dataType="number"
      [caption]="'Grandezza icona' | siaTranslate"
      alignment="left"
      width="150"
    >
    </dxi-column>
    <dxi-column
      dataField="isFullText"
      dataType="boolean"
      [caption]="'Testo a capo' | siaTranslate"
      alignment="center"
      width="100"
    >
    </dxi-column>
    <dxo-editing
      mode="batch"
      refreshMode="repaint"
      [allowUpdating]="true"
      [selectTextOnEditStart]="selectTextOnEditStart"
      [startEditAction]="startEditAction"
    >
    </dxo-editing>

    <dxo-selection mode="single"></dxo-selection>
    <dxo-remote-operations [sorting]="true" [paging]="true">
    </dxo-remote-operations>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-search-panel [visible]="false"></dxo-search-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>
